import styled, { css } from 'styled-components'

import theme from 'live/services/theme'
import CardContainer from 'live/components/ui/CardContainer'

export const Collapsable = styled(CardContainer)`
    z-index: 2;
    border: none;
    border-radius: unset;
    box-shadow: none;
    padding: 2px 0px;
    margin-bottom: 0px;
    background: unset;

    > header {
        z-index: 2;
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        align-items: center;
        position: unset;
        background: unset;

        > div:nth-child(1) {
            width: 100%;
        }

        > div:nth-child(2) {
            justify-content: flex-start;
        }
    }

    input[type='checkbox'] {
        border-radius: 2px !important;
        margin-right: 5px !important;
        height: 16px !important;
        width: 16px !important;
        flex-shrink: 0 !important;

        :checked:after {
            width: 12px !important;
        }

        :indeterminate:after {
            width: 10px !important;
            line-height: 14px !important;
        }
    }
`

interface TitleProps {
    selectable: boolean
}

export const Title = styled.div<TitleProps>`
    width: 100%;
    > div {
        width: 100%;
    }

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    color: ${theme['main-tipography']};
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    padding: 5px;
    height: 30px;

    ${({ selectable }) =>
        selectable &&
        css`
            cursor: pointer;
        `}
    :hover {
        background-color: ${theme['gray-lighter']};
        border-radius: 2px;
    }
`

export const Container = styled.div`
    width: 100%;
    height: 100%;
`
export const TreeContainer = styled.div`
    padding: 1px 20px;
    margin: 0;
`
